import React, { FC, InputHTMLAttributes } from 'react';

interface IProps extends InputHTMLAttributes<HTMLInputElement> {}

const TextField: FC<IProps> = ({ type = 'text', ...rest }) => {
  return (
    <div
      className='w-full max-w-[700px] rounded-lg border-2 border-[#173058] h-[56px]
     has-[input:placeholder-shown]:border-[#17305866] !has-[input:focus]:border-l-primary
    '
    >
      <input
        className='h-full w-full bg-transparent outline-none border-none text-base text-l-primary font-medium px-6'
        {...rest}
      />
    </div>
  );
};

export default TextField;
